import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Pipe({
  name: 'customTranslatePipe',
})
export class CustomTranslatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(query: string, ...args: any[]): Observable<string> {
    return new Observable(observer => {
      this.translateService.get(query, ...args).subscribe((result: string) => {
        const value = result !== query ? result : query.split('.').pop();
        observer.next(value);
      });
    });
  }

}
